
import { defineComponent, nextTick, reactive, ref, toRefs, watch } from "vue";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { IGlobalState } from "@/store";
import { validateUserPassword } from "@/utils/validate";
import { changePassword } from "@/service/api";

export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const store = useStore<IGlobalState>();
    const formItemRef = ref<any>(null);

    const validateRePass = (rule: any, value: string, callback: any) => {
      if (value !== state.formItem.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    const state = reactive({
      formItem: {
        oldPassword: "",
        password: "",
        rePassword: "",
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          { validator: validateUserPassword, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validateUserPassword, trigger: "blur" },
        ],
        rePassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validateRePass, trigger: "blur" },
        ],
      },
    });
    function handleClose() {
      formItemRef.value.resetFields();
      formItemRef.value.clearValidate();
      context.emit("close-modal");
    }
    async function resetPassword() {
      formItemRef.value.validate(async (valid: boolean) => {
        if (valid) {
          const params = {
            userId: store.state.user.id,
            oldPassword:state.formItem.oldPassword,
            password: state.formItem.password,
            rePassword: state.formItem.rePassword,
          };
          const result = await changePassword(params);
          if (result.code == 1) {
            ElMessage({ message: "修改成功！", type: "success" });
            handleClose();
          } else {
            ElMessage({ message: result.msg, type: "error" });
          }
        } else {
          return false;
        }
      });
    }
    watch(
      () => props.dialogVisible,
      async (newVal) => {
        if (newVal) {
           nextTick(()=>{
             formItemRef.value.clearValidate();
           })
        }
      }
    );
    return {
      ...toRefs(state),
      formItemRef,
      resetPassword,
      handleClose,
    };
  },
});
